import gql from "graphql-tag";

export const fragmentAddress = gql`
  fragment AddressFragment on Address {
    areaCode
    city
    cityArea
    companyName
    country {
      __typename
      code
      country
    }
    countryArea
    firstName
    id
    lastName
    phone
    postalCode
    streetAddress1
    streetAddress2
  }
`;
